/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-30 11:26:29
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-10 17:52:56
 */

import Vue from 'vue'
let sessionStorage = {
    // 获取sessionStorage
    getSessionStorage: (name) => {
        if (!name) return
        // let sessionStorage= window.sessionStorage.getItem(name);
        let sessionStorage= window.localStorage.getItem(name);
        return sessionStorage;
    },
    setSessionStorage: (name,value) => {
        if (!name) return
        if (typeof value !== 'string') {
            value = JSON.stringify(value)
        }
        // window.sessionStorage.setItem(name, value)
        window.localStorage.setItem(name, value)
    },
    //删除sessionStorage存储数据
    removeSessionStorage: (name) => {
        if (!name) return
        // window.sessionStorage.removeItem(name)
        window.localStorage.removeItem(name)
    },
    // 清空sessionStorage存储数据
    clearSessionStorage: () => {
        // window.sessionStorage.clear()
        window.localStorage.clear()
    },
}
//获取sessionStorage方法挂载于Vue
Vue.prototype.$getSessionStorage = sessionStorage.getSessionStorage;
Vue.prototype.$setSessionStorage = sessionStorage.setSessionStorage;
Vue.prototype.$removeSessionStorage = sessionStorage.removeSessionStorage;
Vue.prototype.$clearSessionStorage = sessionStorage.clearSessionStorage;
    


// WEBPACK FOOTER //
// ./src/js/sessionStorage.js